module.exports = __webpack_public_path__ + "img/404.7e3ff56e.png";